<template>
    <v-dialog 
        v-model="visible" 
        transition="dialog-top-transition" 
        scrollable 
        persistent 
        max-width="600"
        content-class="dialog-full-height"
    >
        <v-card class="modal-maincard p-relative">
            <v-overlay v-if="false" absolute>
                <v-progress-circular
                    indeterminate
                    size="40"
                    width="2"
                    color="#a94442"
                ></v-progress-circular>
            </v-overlay>
            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(this.title) }} {{ this.titleInterval }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text class="wrapperFormModal">
                
                <v-card flat style="min-height:100%;">
                    <v-card-text>

                        <v-form ref="form" lazy-validation>

                            <v-row 
                                v-if="isWeekDaysVisible"
                                no-gutters
                            >

                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">
                                        {{ $t("Дни_недели") }}
                                    </label>
                                </v-col>

                                <v-col cols="12" sm="12" md="9">
                                    <div class="onlyReadData more-per-lab-wrap justify-space-around">
                                        <v-chip
                                            v-for="(item, i) in weekDays"
                                            :key="i"
                                            class="person-label immutable-text"
                                            small
                                            label
                                            :dark="isDarkweekDay(item)"
                                            :color="weekDayColor(item)"
                                            @click="weekDayClick(item)"
                                        >
                                            {{item}}
                                        </v-chip>
                                    </div>
                                </v-col>

                            </v-row>

                            <v-row 
                                v-if="isMonthDaysVisible"
                                no-gutters
                                >

                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">
                                        {{ $t("Даты") }}
                                    </label>
                                </v-col>

                                <v-col cols="12" sm="12" md="9">
                                    <v-date-picker
                                        v-model="dates"
                                        class="datepicker-without-header datepicker-without-table-header"
                                        color="teal"
                                        :first-day-of-week="1"
                                        no-title
                                        multiple
                                        full-width
                                        :allowed-dates="allowedDates"
                                        :picker-date="pickerDate"
                                    >
                                    </v-date-picker>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Время") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <div class="more-inputs-in-row">
                                        <vue-timepicker 
                                            v-model="beginTime"
                                            placeholder=' '
                                            close-on-complete
                                            auto-scroll
                                            hide-clear-button
                                            hide-disabled-items
                                            :hour-range="upperHourLimit > 0 ? [[ 8, upperMinutesLimit == 0 ? upperHourLimit - 1 : upperHourLimit ]] : [[8, 20]]"
                                            :minute-interval="10"
                                        >
                                            <template v-slot:clearButton>
                                                <i class="fas fa-times"></i>
                                            </template>
                                        </vue-timepicker>
                                        <span>{{ $t("по") }}</span>
                                        <vue-timepicker 
                                            v-model="endTime"
                                            placeholder=' '
                                            close-on-complete
                                            auto-scroll
                                            hide-clear-button
                                            hide-disabled-items
                                            :hour-range="lowerHourLimit > 0 ? [[ lowerMinutesLimit == 50 ? lowerHourLimit + 1 : lowerHourLimit, 20 ]] : [[8, 20]]"
                                            :minute-interval="10"
                                        >
                                            <template v-slot:clearButton>
                                                <i class="fas fa-times"></i>
                                            </template>
                                        </vue-timepicker>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Интервал") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <div class="more-inputs-in-row">
                                        <vue-timepicker 
                                            v-model="intervalTime"
                                            placeholder=' '
                                            close-on-complete
                                            auto-scroll
                                            hide-clear-button
                                            hide-disabled-items
                                            :hour-range="[[0, 5]]"
                                            :minute-interval="10"
                                        >
                                            <template v-slot:clearButton>
                                                <i class="fas fa-times"></i>
                                            </template>
                                        </vue-timepicker>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Активный_с") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <div class="more-inputs-in-row">
                                        <v-menu 
                                            v-model="activeFromDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    :value="activeFromDate | formattedDate"
                                                    prepend-icon="mdi-calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on" 
                                                    hide-details
                                                    required
                                                    outlined
                                                    dense
                                                    class="datepick-input flex-grow-1"
                                                    style="width:calc(100% + 36px)!important;"
                                                >
                                                </v-text-field>
                                            </template>

                                            <v-date-picker
                                                v-model="activeFromDate"
                                                @input="activeFromDateMenu = false"
                                                color="teal"
                                                :first-day-of-week="1"
                                                :allowed-dates="allowedActiveDates"
                                            >
                                            </v-date-picker>
                                        </v-menu>
                                        <span class="miir-text-cap"></span>
                                        <vue-timepicker 
                                            v-model="activeSinceTime"
                                            placeholder=' '
                                            close-on-complete
                                            auto-scroll
                                            hide-clear-button
                                            hide-disabled-items
                                            :hour-range="[[7, 20]]"
                                            :minute-interval="10"
                                        >
                                        </vue-timepicker>
                                    </div>
                                </v-col>
                            </v-row>
                            <!--
                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Время_c") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9" class="d-flex">
                                    <div class="d-flex align-center mr-2 slider-result-text">
                                        {{ leadingZero(hourSliderBeginValue) }} : {{ leadingZero(minutesSliderBeginValue) }}
                                    </div>
                                    <div class="d-flex flex-column flex-grow-1 justify-space-between">
                                        <v-slider
                                            v-model="hourSliderBeginValue"
                                            step="1"
                                            min="8"
                                            max="20"
                                            ticks="always"
                                            hide-details
                                            track-color="teal"
                                            color="teal"
                                        ></v-slider>
                                        <v-slider
                                            v-model="minutesSliderBeginValue"
                                            step="10"
                                            max="50"
                                            ticks="always"
                                            hide-details
                                            track-color="teal"
                                            color="teal"
                                        ></v-slider>
                                    </div>
                                    <div class="d-flex align-center mr-2 slider-result-text">
                                        {{ leadingZero(hourSliderEndValue) }} : {{ leadingZero(minutesSliderEndValue) }}
                                    </div>
                                    <div class="d-flex flex-column flex-grow-1 justify-space-between">
                                        <v-slider
                                            v-model="hourSliderEndValue"
                                            step="1"
                                            min="8"
                                            max="20"
                                            ticks="always"
                                            hide-details
                                            track-color="teal"
                                            color="teal"
                                        ></v-slider>
                                        <v-slider
                                            v-model="minutesSliderEndValue"
                                            step="10"
                                            max="50"
                                            ticks="always"
                                            hide-details
                                            track-color="teal"
                                            color="teal"
                                        ></v-slider>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Время_по") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9" class="d-flex">
                                    <div class="d-flex align-center mr-2 slider-result-text">
                                        {{ leadingZero(hourSliderEndValue) }} : {{ leadingZero(minutesSliderEndValue) }}
                                    </div>
                                    <div class="d-flex flex-column flex-grow-1 justify-space-between">
                                        <v-slider
                                            v-model="hourSliderEndValue"
                                            step="1"
                                            min="8"
                                            max="20"
                                            ticks="always"
                                            hide-details
                                            track-color="teal"
                                            color="teal"
                                        ></v-slider>
                                        <v-slider
                                            v-model="minutesSliderEndValue"
                                            step="10"
                                            max="50"
                                            ticks="always"
                                            hide-details
                                            track-color="teal"
                                            color="teal"
                                        ></v-slider>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Интервал") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9" class="d-flex">
                                    <div class="d-flex align-center mr-2 slider-result-text">
                                        {{ leadingZero(hourSliderIntervalValue) }} : {{ leadingZero(minutesSliderIntervalValue) }}
                                    </div>
                                    <div class="d-flex flex-column flex-grow-1 justify-space-between">
                                        <v-slider
                                            v-model="hourSliderIntervalValue"
                                            step="1"
                                            max="5"
                                            ticks="always"
                                            hide-details
                                            track-color="teal"
                                            color="teal"
                                        ></v-slider>
                                        <v-slider
                                            v-model="minutesSliderIntervalValue"
                                            step="10"
                                            max="50"
                                            ticks="always"
                                            hide-details
                                            track-color="teal"
                                            color="teal"
                                        ></v-slider>
                                    </div>
                                </v-col>
                            </v-row>
                            -->
                            <v-row 
                                v-if="isWorkTimeVisible"
                                no-gutters
                                >
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">
                                        {{ $t("Периоды") }}
                                    </label>
                                </v-col>

                                <v-col cols="12" sm="12" md="9" class="d-flex align-center">
                                    <div class="time-intervals-wrap">
                                        <template
                                           v-for="(group, groupIndex) in groupedTimeIntervals"
                                            
                                        >
                                            <div 
                                                v-if="group.length > 0"
                                                :key="groupIndex" 
                                                class="tiw-chip-group"
                                            >
                                                <v-chip
                                                    v-for="(item, itemIndex) in group"
                                                    :key="itemIndex"
                                                    class="person-label immutable-text"
                                                    small
                                                    label   
                                                    :dark="isDarkInterval(item)"
                                                    :color="timeIntervalColor(item)"
                                                    @click="timeIntervalClick(item)"
                                                >
                                                    {{item}}
                                                </v-chip>
                                            </div>
                                        </template>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-alert
                                v-model="alertMessage"
                                color="orange lighten-4"                                                     
                            >
                                <div class="alert-text-wrapper">
                                    <div
                                        v-for="(errorMsg, i) in errors"
                                        :key="i"
                                        class="alert-text"
                                    >
                                        {{ errorMsg }}
                                    </div>
                                </div>
                                
                            </v-alert>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn 
                    color="cyan" 
                    text
                    depressed
                    :disabled="!isValid"
                    @click="onSave"
                >
                    {{$t("Добавить")}}
                </v-btn>

                <v-btn 
                    color="blue-grey" 
                    text
                    depressed 
                    @click="cancel"
                >
                    {{$t("Закрыть")}}
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import { httpAPI } from "@/api/httpAPI";
import sys from '@/services/system';

export default {
    name: "ReceptionScheduleDlg",
    components: {
        VueTimepicker
    },
    data () {
        return {
            title: "График приема",
            visible: false,
            dates: [],
            weekDays: ['Пн','Вт','Ср','Чт','Пт','Сб','Вс'],
            selectedWeekDays: [1, 1, 1, 1, 1, 0, 0],
            timeIntervals: [],
            selectedIntervals: [],
            beginTime: "09:00",
            endTime: "18:00",
            intervalTime: "01:00",
            activeFromDate: "",
            activeFromDateMenu: false,
            activeSinceTime: "00:00",

            hourSliderBeginValue: 0,
            minutesSliderBeginValue: 0,
            hourSliderEndValue: 0,
            minutesSliderEndValue: 0,
            hourSliderIntervalValue: 0,
            minutesSliderIntervalValue: 0,

            alertMessage: false,
            errors: []
        }
    },
    computed: {        
        ...mapGetters('qalaQyzmet/receptionSchedule/calendar', 
        { 
            getCalendarPeriod: 'getCurrentPeriod', 
            getStartDate: 'getStartDate', 
            getEndDate: 'getEndDate' 
        }),
        //day, week, month
        isWeekDaysVisible() {
            return this.getCalendarPeriod == "month" || this.getCalendarPeriod == "week";
        },
        isMonthDaysVisible() {
            return this.getCalendarPeriod == "month"
        },
        isWorkTimeVisible() {
            return true; 
        },
        //для выбора времени
        
        lowerHourLimit() {
            let hStr = this.beginTime.split(':')[0];
            return Number(hStr)
        },
        lowerMinutesLimit() {
            let mStr = this.beginTime.split(':')[1];
            return Number(mStr)
        },
        
        upperHourLimit() {
            let hStr = this.endTime.split(':')[0];
            return Number(hStr)
        },
        upperMinutesLimit() {
            let mStr = this.endTime.split(':')[1];
            return Number(mStr)
        },
        isValid() {
            switch(this.getCalendarPeriod) {
                case 'day': return this.selectedIntervals.length > 0;
                case 'week': return this.selectedWeekDays.some( x => x == 1) &&  this.selectedIntervals.length > 0;
                case 'month': return this.dates.length > 0 && this.selectedIntervals.length > 0;
            }   
            
            return false;
        },
        pickerDate() {
            return this.getStartDate;
        },
        titleInterval() {
            switch(this.getCalendarPeriod) {
                case 'day': return this.$moment(this.getStartDate).format('DD.MM.YYYY');
                case 'week': return `${this.$moment(this.getStartDate).format('DD.MM.YYYY')} - ${this.$moment(this.getEndDate).format('DD.MM.YYYY')}`;
                case 'month': return `${this.$moment(this.getStartDate).format('DD.MM.YYYY')} - ${this.$moment(this.getEndDate).format('DD.MM.YYYY')}`;
            }  

            return '';
        },
        groupedTimeIntervals() {
            const groups = Array.from({ length: 4 }, () => []);
            const itemsPerGroup = Math.ceil(this.timeIntervals.length / 4);

            // Распределение элементов по группам
            this.timeIntervals.forEach((item, index) => {
                const groupIndex = Math.floor(index / itemsPerGroup);
                // Защита от выхода за пределы массива групп для очень маленьких массивов
                if (groups[groupIndex]) {
                groups[groupIndex].push(item);
                }
            });
            return groups;
        }
    },
    methods: {
        ...mapActions('qalaQyzmet/receptionSchedule/calendar', 
        { 
            updateEvents: 'updateEvents' 
        }),
        allowedDates(val) {
            // console.log(this.$moment(val), this.$moment(), this.$moment(val) >= this.$moment().startOf('day'))
            let weekday = this.$moment(val).isoWeekday() - 1;
            return this.selectedWeekDays[weekday] == 1 && this.$moment(val) >= this.$moment().startOf('day');
        },
        isDarkweekDay(item) {
            let index = this.weekDays.indexOf(item);
            return this.selectedWeekDays[index] == 1; 
        },
        weekDayColor(item) {
            let index = this.weekDays.indexOf(item);
            return this.selectedWeekDays[index] == 1 ? "teal" : "#d8d8d8";
        },
        weekDayClick(item) {            
            let index = this.weekDays.indexOf(item);
            this.$set(this.selectedWeekDays, index, this.selectedWeekDays[index] === 0 ? 1 : 0);
        },
        isDarkInterval(item) {
            return this.selectedIntervals.includes(item);
        },        
        timeIntervalColor(item) {
            return this.selectedIntervals.includes(item) ? "teal" : "#d8d8d8";
        },
        timeIntervalClick(item) {
            if (!this.selectedIntervals.includes(item))                
                this.selectedIntervals = [...this.selectedIntervals, item];
            else
                this.selectedIntervals = this.selectedIntervals.filter(i => i != item);
        },
        async open() {
            this.init();
            this.visible = true;            
        },
        cancel() {
            this.visible = false;
            this.updateEvents();
        },
        generateDateRange(startDate, endDate) {   

            const dates = [];
            const start = this.$moment(startDate);
            const end = this.$moment(endDate);
            
            while (start.isSameOrBefore(end)) {
                if (this.selectedWeekDays[start.isoWeekday() - 1] == 1)
                    dates.push(start.format('YYYY-MM-DD'));

                start.add(1, 'day');
            }
            
            return dates;
        },
        async onSave() {
            let dates;

            switch(this.getCalendarPeriod) {
                case 'day': 
                    dates = [this.getStartDate];
                break;
                case 'week':
                    dates = [...this.generateDateRange(this.getStartDate, this.getEndDate)];
                break;
                case 'month':
                    dates = [...this.dates];
                break;
            }  

            //console.log(dates, this.getStartDate, this.getEndDate);

            let response = await httpAPI({
                url: `api/csc/requests/packaddreceptions`,
                method: 'POST',
                data: { Content : JSON.stringify({ Dates: dates, Intervals: this.selectedIntervals.sort(), ActiveFrom: `/Date(${ Date.parse(`${this.activeFromDate}T${this.activeSinceTime}:00`) })/` }) }
            });

            //console.log(response);

            if (response.data?.Payload?.Errors?.length > 0) {
                this.alertMessage = true
                this.errors = response.data?.Payload?.Errors;            
            }
            else
                this.cancel();            
        },
        timeIsValid() {
            let beginDateTime = this.$moment(this.beginTime, 'HH:mm');
            let endDateTime = this.$moment(this.endTime, 'HH:mm');
            let minutesDiff = endDateTime.diff(beginDateTime, 'minutes');
            return minutesDiff > 0;
        },
        leadingZero(number) {
            return String(number).padStart(2, '0');
        },
        setDates() {
            const dates = [];
            const today = this.$moment();
            const firstDay = this.$moment(this.getStartDate);
            const endOfMonth = this.$moment(this.getStartDate).endOf('month');

            let currentDate = firstDay.isSameOrBefore(today, 'day') ? today.clone() : firstDay.clone();
            
            while (currentDate.isSameOrBefore(endOfMonth, 'day')) {
                const dayOfWeek = currentDate.day();
                const weekDayIndex = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
                
                if (this.selectedWeekDays[weekDayIndex] === 1) {
                    dates.push(currentDate.format('YYYY-MM-DD'));
                }
                
                currentDate.add(1, 'day');
            }
            
            this.dates = dates;
        },
        init() {
            this.activeFromDate = this.$moment().format('YYYY-MM-DD');
            this.errors = [];
            this.selectedWeekDays = [1, 1, 1, 1, 1, 0, 0];
            this.setDates();
            this.setTimeIntervals();
        },
        setTimeIntervals() {
            this.selectedIntervals = [];
            const intervals = [];
            
            // Функция для конвертации "HH:mm" в минуты
            const timeToMinutes = (time) => {
                const [hours, minutes] = time.split(':').map(Number);
                return hours * 60 + minutes;
            };
            
            // Функция для конвертации минут в "HH:mm"
            const minutesToTime = (minutes) => {
                const hours = Math.floor(minutes / 60);
                const mins = minutes % 60;
                return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
            };
            
            const startMinutes = timeToMinutes(this.beginTime);
            const endMinutes = timeToMinutes(this.endTime);
            const intervalMinutes = timeToMinutes(this.intervalTime);
            
            if (intervalMinutes == 0) {
                this.timeIntervals = [];
                return;
            }

            let currentMinutes = startMinutes;
            
            while (currentMinutes + intervalMinutes <= endMinutes) {
                const intervalStart = minutesToTime(currentMinutes);
                const intervalEnd = minutesToTime(currentMinutes + intervalMinutes);
                
                intervals.push(`${intervalStart} - ${intervalEnd}`);
                
                currentMinutes += intervalMinutes;
            }
            
            this.timeIntervals = intervals
        },
        allowedActiveDates(val) {
            return this.$moment(val, 'YYYY-MM-DD').isSameOrAfter(this.$moment(), 'day');
        },
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    watch: {
        selectedWeekDays() {
            this.setDates();
        },
        beginTime() 
        {
            this.setTimeIntervals();
        },
        endTime() 
        {
            this.setTimeIntervals();
        },
        intervalTime() 
        {
            this.setTimeIntervals();
        },
        hourSliderBeginValue() 
        {
            this.setTimeIntervals();
        },
        // minutesSliderBeginValue() 
        // {
        //     this.setTimeIntervals();
        // },
        // hourSliderEndValue() 
        // {
        //     this.setTimeIntervals();
        // },
        // minutesSliderEndValue() 
        // {
        //     this.setTimeIntervals();
        // },
        // hourSliderIntervalValue() 
        // {
        //     this.setTimeIntervals();
        // },
        // minutesSliderIntervalValue() 
        // {
        //     this.setTimeIntervals();
        // },
    }    
}
</script>